/**
 * Shortens long addresses for compact card display.
 * Prefers "street, city" when comma-separated; otherwise truncates with ellipsis.
 */
export const shortenAddress = (address: string, maxLength = 42): string => {
  const normalized = address?.trim() ?? "";
  if (!normalized) {
    return "";
  }
  if (normalized.length <= maxLength) {
    return normalized;
  }

  const parts = normalized
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length >= 2) {
    const compact = `${parts[0]}, ${parts[parts.length - 1]}`;
    if (compact.length <= maxLength) {
      return compact;
    }
  }

  return `${normalized.slice(0, maxLength - 1)}…`;
};
